import React, { Component, Fragment } from 'react';
import '../css/inicio.css';
import CardMedia from '@material-ui/core/CardMedia';
//imagenes
import Logo from '../img/logo1.png';
import Demo from '../img/DemoLogo.png';
import DescargaPlayStore from '../img/download-button.svg';
import DescargaAppStore from '../img/download-button-app.svg';
//componentes
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';

class Inicio extends Component {
    render() {
        return (
           <Fragment>
               <Nav />

                <div className="position-relative overflow-hidden p-3 p-md-3 m-md-3 text-center bg-light">
                    <div className="mx-auto">
                        <p className="contenedorlogo">
                            <img src={Demo}/>
                        </p>
                        <p className="lead font-weight-normal">
                            Realiza tus pedidos en Demo App, ten acceso a todos nuestros productos.
                        </p>
                        <a href="#">
                            <img src={DescargaPlayStore}/>
                        </a>
                        <a href="#">
                            <img src={DescargaAppStore}/>
                        </a>
                    </div>
                </div>

                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div className="bg-dark mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden">
                        <h2 className="display-5">INFORMACIONS</h2>
                        <br/><br/>
                        <h3 className="display-5">INFORMACIONS</h3>
                        <br/><br/>
                        <p className="lead">
                            1.- INFORMACIONS
                        </p>
                        <p className="lead">
                            2.- INFORMACIONS
                        </p>
                        <p className="lead">
                            3.- INFORMACIONS
                        </p>
                        <p className="lead">
                            4.- INFORMACIONS
                        </p>
                        <p className="lead">
                            5.- INFORMACIONS 
                        </p>
                        <p className="lead">
                            6.- INFORMACIONS 
                        </p>
                        <p className="lead">
                            7.- INFORMACIONS
                        </p>
                        <p className="lead">
                            8.- INFORMACIONS 
                        </p>
                    </div>
                    <div className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
                        <br/><br/>
                        <h3 className="display-5">INFORMACIONS</h3>
                        <img className="img-fluid rounded" src={Demo}/>
                    </div>
                </div>

                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
                        <br/><br/>
                        <h3 className="display-5">INFORMACIONS</h3>
                        <img className="img-fluid rounded" src={Demo}/>
                    </div>
                    <div className="bg-dark mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden">
                        <div className="my-3 py-3">
                        <h2 className="display-5">INFORMACIONS</h2>
                        <br/><br/>
                        <h3 className="display-5">INFORMACIONS</h3>
                        <p className="lead">
                        INFORMACIONS
                        </p>
                        <br/><br/>
                        <h3 className="display-5">INFORMACIONS</h3>
                        <p className="lead">
                        INFORMACIONS
                        </p>
                        <br/><br/>
                        <h3 className="display-5">INFORMACIONS</h3>
                        <p className="lead">
                            VIsita nuestra página de Facebook <a href="#"
                        target="_blank">Demo</a> será un placer ayudarte.
                        </p>
                        <br/><br/>
                        <a href="#">
                            <img src={DescargaPlayStore}/>
                        </a>
                        <a href="#">
                            <img src={DescargaAppStore}/>
                        </a>
                        </div>
                    </div>
                </div>

                <Footer />
           </Fragment>
        )
    }
}

export default Inicio;